// @flow
import callFetchClient from '$api/fetchClient'
import {callWithFlags, setState} from '$util'

export default function* fetchClient(clientId: string): Generator<> {
  const {data: client} = yield callWithFlags('client', callFetchClient, clientId)
  yield setState('client', state => client)
}



// WEBPACK FOOTER //
// ./src/client/sagas/fetchClient.js